import React from 'react';
import { Link } from 'react-router-dom';
import { brands } from '../../data/navigation';
export function BrandStrip() {
  return <section aria-labelledby="brands-heading" className="mx-auto max-w-7xl px-4 pb-14 sm:px-6 lg:px-8 lg:pb-20" data-id="element-83" data-mp="3dsnr4prr2lm4">
      <h2 id="brands-heading" className="text-2xl font-bold tracking-tight text-ink sm:text-[32px]" data-id="element-84" data-mp="3ipw9aqcwepnd">
        A-merken, uit voorraad leverbaar
      </h2>
      <ul className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8" data-id="element-85" data-mp="3shtpycmoe9th">
        {brands.map(b => <li key={b} data-id="element-86" data-mp="19oall0wgf71">
            <Link to="/shop" className="flex h-20 items-center justify-center rounded-xl border border-line bg-white px-3 text-center text-base font-extrabold tracking-tight text-ink/50 transition-colors duration-150 hover:border-ink/30 hover:text-ink" data-id="element-87" data-mp="18wbw1c0a1cj">
              {b}
            </Link>
          </li>)}
      </ul>
    </section>;
}